import { Toggler } from '@hh.ru/magritte-ui-tree-selector/strategy/types';

/**
 * Создаёт переключатель для набора с возможностью выбора только одного элемента.
 */
const createSingleValueToggler = (): Toggler => {
    /**
     * Переключает элемент в наборе, при необходимости сбрасывая предыдущий выбранный.
     * @param set Исходный набор
     * @param id Переключаемый элемент
     * @param state Новое состояние переключаемого элемента (true — в наборе, false — нет)
     * @returns Признак того, что набор изменился.
     */
    return (set: Set<string>, id: string, state: boolean) => {
        /**
         * Всего возможно 6 случаев:
         * 1. toggle([2], 2, true)  => [2], return false
         * 2. toggle([1], 2, true)  => [2], return true
         * 3. toggle([ ], 2, true)  => [2], return true
         * 4. toggle([2], 2, false) => [ ], return true
         * 5. toggle([1], 2, false) => [1], return false
         * 6. toggle([ ], 2, false) => [ ], return false
         */
        if (state) {
            if (set.has(id)) {
                // 1
                return false;
            }
            if (set.size) {
                // 2
                set.clear();
            }
            // 3
            set.add(id);
            return true;
        } else if (set.has(id)) {
            // 4
            set.delete(id);
            return true;
        }
        // 5, 6
        return false;
    };
};

export default createSingleValueToggler;
